<div
  [id]="id"
  fxLayout="row"
  fxLayout.lt-lg="column"
  fxLayoutGap="20px"
  [ngClass]="{ preview: isPreview }"
  class="table-margin"
>
  <div
    [fxFlex]="data?.length! > 0 && !isPreview ? '50' : '100'"
    fxFlex.lt-lg="100"
  >
    <nz-layout>
      <nz-header class="table-header">
        @if (isEOC() || isInpatientView() || isPreview || (data?.length! > 0 ||
        isLoading)) {
        <div class="table-header-row margin-lr">
          <div class="table-header-cell">
            {{ "veles.moca.title" | translate }}
          </div>
          <div
            class="table-header-cell margin-lrr"
            *hasAddPermissions="['a-sqa']"
          >
            @if ( (isEOC() || isInpatientView()) && !readonlyMode && !isPreview ) {
            <button nz-button nzShape="round" (click)="openModal()">
              <div fxLayout="row">
                <div fxLayout="col">
                  <mat-icon class="add-icon">add_circle_outline</mat-icon>
                </div>
                <div fxLayout="col" class="add-title">
                  {{ "Add" | translate }}
                  {{ "veles.moca.title" | translate }}
                </div>
              </div>
            </button>
            }
          </div>
        </div>
        } @if ( !(isEOC() || isInpatientView()) && !isPreview && !(data?.length!
        > 0) ) {
        <div fxLayout="row" class="table-header-row">
          @if (!isLoading) {
          <div fxLayout="col" class="title">
            {{ "veles.moca.title" | translate }} -
            {{ "No data available" | translate }}
          </div>
          }
        </div>
        }
      </nz-header>
      @if (data?.length! > 0 || isLoading) {
      <nz-content>
        <nz-table
          #nzTable
          nzTableLayout="fixed"
          nzShowTitle="false"
          nzSize="middle"
          nzNoResult="No MoCA assessments found"
          [nzLoading]="isLoading"
          [nzData]="data || []"
          [nzShowPagination]="pagination"
          [nzShowSizeChanger]="pagination"
          nzPaginationType="default"
          [nzFrontPagination]="pagination"
          [nzPageIndex]="currentPageIndex"
          (nzPageIndexChange)="handlePageIndexChange($event)"
          (nzPageSizeChange)="handlePageSizeChange($event)"
          [nzPageSizeOptions]="[5, 10, 20]"
          [nzPageSize]="pageSize"
        >
          <thead>
            <tr>
              @for (col of ['Score', 'File', 'Last Updated']; track col) {
              <th>
                {{ col | translate }}
                <app-tooltip [fieldName]="col" area="MoCA Assessment" />
              </th>
              } @if (hasUnsubmitted() && !isPreview) {
              <th nzWidth="70px">
                {{ "Actions" | translate }}
                <app-tooltip fieldName="Actions" area="MoCA Assessment" />
              </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (item of getData(); track item) {
            <tr
              [ngClass]="{'draft-entry': !item?.['isSubmitted'] && (isEOC()||isInpatientView()), 'selected-preview': pdfItem?.id === item.id}"
              (click)="requestPDF(item)"
            >
              <td>{{ getValue('score', item.score.toString()) }}</td>
              <td>{{ getValue('file', item.fileName || undefined) }}</td>
              <td>{{ getValue('date time', item.updatedAtUtc) }}</td>
              @if ( (isEOC() || isInpatientView()) && !item['isSubmitted'] &&
              !isPreview ) {
              <td>
                <i
                  nz-icon
                  nzType="icons:delete"
                  nzTheme="outline"
                  class="delete-btn"
                  (click)="deleteFun(item.id); $event.stopPropagation()"
                ></i>
              </td>
              }
            </tr>
            }
          </tbody>
        </nz-table>
      </nz-content>
      }
    </nz-layout>
  </div>
  @if (data?.length! > 0 && !isPreview) {
  <div [fxFlex]="50" fxFlex.lt-lg="100">
    <div class="document-view">
      <div class="preview-title">
        {{ "Preview" | translate }}
        {{ fileName ? " - " + fileName : "" }}@if (pdfObj && !isPreviewLoading)
        {
        <span
          nz-icon
          nzType="icons:download"
          nzTheme="outline"
          class="download-btn"
          (click)="downloadPDF(pdfItem!)"
        ></span>
        }
      </div>
      <div class="preview-content" fxLayoutAlign="center center">
        @if (!pdfObj && !isPreviewLoading) {
        <div>
          <i
            nz-icon
            nzType="icons:folder-view"
            nzTheme="outline"
            class="folder-view-icon"
          ></i>
          <div>{{ "veles.moca.selectToPreview" | translate }}</div>
        </div>
        } @if (isPreviewLoading) {
        <div><nz-spin nzSimple></nz-spin></div>
        }

        @if (pdfObj && pdfItem && !isPreviewLoading && fileType ==
        'application/pdf') {
        <pdf-viewer
          class="pdf-viewer"
          [src]="pdfObj"
          [render-text]="true"
          [original-size]="false"
          [fit-to-page]="true"
          (click)="isVisible = true"
        >
        </pdf-viewer>
        }

        @if (pdfObj && pdfItem && !isPreviewLoading &&
        fileType?.startsWith('image')) {
        <img
          nz-image
          [nzSrc]="pdfObj"
          nzWidth="auto"
          nzHeight="auto"
          class="image-viewer"
        />
        }
      </div>
    </div>
  </div>
  }
</div>

<nz-modal
  #modalRef
  nzSize
  [(nzVisible)]="isVisible"
  [nzTitle]="('Preview' | translate) + (fileName ? ' - ' + fileName : '')"
  (nzOnCancel)="handleCancel()"
  nzCancelText="Cancel"
  nzOkText="Save"
  nzOkType="primary"
  [nzFooter]="null"
  class="custom-modal-class"
>
  <ng-container *nzModalContent>
    <pdf-viewer
      class="modal-pdf"
      [src]="pdfObj"
      [render-text]="true"
      [original-size]="false"
    ></pdf-viewer>
  </ng-container>
</nz-modal>

<div *ngComponentOutlet="addComp"></div>
